var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGifShow)?_c(_vm.canvasTag,{ref:"gifCanvas",tag:"component",staticClass:"gif-canvas po",style:(_vm.getStyles)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }